var map = {
	"./da-flag.svg": 985,
	"./de-flag.svg": 146,
	"./el-flag.svg": 6872,
	"./en-gb-flag.svg": 3614,
	"./en-us-flag.svg": 887,
	"./es-es-flag.svg": 1414,
	"./es-mx-flag.svg": 7303,
	"./fi-flag.svg": 5900,
	"./fr-ca-flag.svg": 6166,
	"./fr-fr-flag.svg": 7702,
	"./id-flag.svg": 9004,
	"./in-flag.svg": 6242,
	"./it-flag.svg": 3164,
	"./ja-flag.svg": 8920,
	"./ko-flag.svg": 5275,
	"./nl-flag.svg": 599,
	"./no-flag.svg": 4086,
	"./pl-flag.svg": 8437,
	"./pt-br-flag.svg": 8174,
	"./pt-pt-flag.svg": 8034,
	"./ru-flag.svg": 4812,
	"./sv-flag.svg": 5596,
	"./tr-flag.svg": 455,
	"./uk-flag.svg": 5113,
	"./unknown-flag.svg": 295,
	"./vi-flag.svg": 9724,
	"./zh-cn-flag.svg": 1165,
	"./zh-hk-flag.svg": 1305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5038;